// extracted by mini-css-extract-plugin
export default {"main":"App_main__Gu0Bi"};